import { useEffect, useState, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DashboardLayout from "../../controls/DashboardLayout";
import DashboardNavbar from "../../controls/DashboardNavbar";
import MDBox from "../../controls/MDBox";
import { Grid } from "@mui/material";
import { Card } from "react-bootstrap";
import MDTypography from "../../controls/MDTypography";
import MDButton from "../../controls/MDButton";
import DataTable from "../../controls/Tables/DataTable";
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import { postData, pathData, deleteData, getData } from "../../Utils/Http/api";
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

function JudEventoTipoListar() {
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [dataVersion, setDataVersion] = useState(0);
    const [openDialog, setOpenDialog] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [tipoEvento, setTipoEvento] = useState("");
    const [plazoEnDias, setPlazoEnDias] = useState(0);
    const [observaciones, setObservaciones] = useState("");
    const [subEstados] = useState([
        { id: 1, label: "GESTION" },
        { id: 2, label: "CAUTELAR" },
        { id: 3, label: "PROCESAL" }
    ]);
    const [estados, setEstados] = useState([]);
    const [selectedSubEstado, setSelectedSubEstado] = useState(null);
    const [selectedEstado, setSelectedEstado] = useState(null);
    const [snackbar, setSnackbar] = useState({ open: false, msg: '', severity: 'success' });
    const [openDelete, setOpenDelete] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [filtroTipoEvento, setFiltroTipoEvento] = useState("");
    const [filtroSubEstado, setFiltroSubEstado] = useState(null);
    const [filtroEstado, setFiltroEstado] = useState(null);

    const fetchEstados = async () => {
        try {
            const res = await getData('/JudEstadoListar', { estado: "", subEstado: "" });
            const list = res?.value || [];
            setEstados(list.map(e => ({ id: e.idJudEstado, label: e.estado, subEstado: e.subEstado })));
        } catch (ex) {
            console.error('Error cargando estados', ex);
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const params = {
                tipoEvento: filtroTipoEvento || "",
                estado: filtroEstado?.label || "",
                subEstado: filtroSubEstado?.label || ""
            };
            const res = await getData('/JudEventoTipoListar', params);
            const list = res?.value || [];
            
            const newColumns = [
                { Header: 'Tipo Evento y Estado', accessor: 'detalle', align: 'left', width: '50%' },
                { Header: 'Plazo', accessor: 'plazo', align: 'center', width: '10%' },
                { Header: 'Observaciones', accessor: 'observaciones', align: 'left', width: '20%' },
                { Header: 'Acciones', accessor: 'action', align: 'center', width: '20%' }
            ];
            
            const data = list.map(item => {
                const detalle = (
                    <MDBox>
                        <MDTypography variant="h6" color="text" fontWeight="medium">
                            {item.tipoEvento}
                        </MDTypography>
                        <MDTypography variant="caption" color="info" fontWeight="medium">
                            Estado: {item.estado || 'N/A'}
                        </MDTypography>
                        <br />
                        <MDTypography variant="caption" color="secondary" fontWeight="medium">
                            Sub Estado: {item.subEstado || 'N/A'}
                        </MDTypography>
                    </MDBox>
                );
                const plazo = (
                    <MDTypography variant="body2" color="text">
                        {item.plazoEnDias} días
                    </MDTypography>
                );
                const observaciones = (
                    <MDTypography variant="caption" color="text">
                        {item.observaciones || '-'}
                    </MDTypography>
                );
                const action = (
                    <MDBox display="flex" gap={1} alignItems="center" justifyContent="center">
                        <IconButton
                            size="small"
                            onClick={() => handleOpenEdit(item)}
                            aria-label="editar"
                        >
                            <EditIcon color="info" />
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={() => { setDeleteId(item.idJudEventoTipo); setOpenDelete(true); }}
                            aria-label="eliminar"
                        >
                            <DeleteIcon color="error" />
                        </IconButton>
                    </MDBox>
                );
                return {
                    id: item.idJudEventoTipo,
                    detalle,
                    plazo,
                    observaciones,
                    action
                };
            });

            setColumns(newColumns);
            setRows([...data]);
        } catch (ex) {
            console.error('Error cargando tipos de evento judicial', ex);
            setSnackbar({ open: true, msg: 'Error al cargar los tipos de evento judicial', severity: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEstados();
    }, []);

    useEffect(() => {
        if (estados.length > 0) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshKey, estados]);

    const handleOpenAdd = () => {
        setEditMode(false);
        setCurrentItem(null);
        setTipoEvento("");
        setPlazoEnDias(0);
        setObservaciones("");
        setSelectedSubEstado(null);
        setSelectedEstado(null);
        setOpenDialog(true);
    };

    const handleLimpiarFiltros = () => {
        setFiltroTipoEvento("");
        setFiltroSubEstado(null);
        setFiltroEstado(null);
        setRefreshKey(prev => prev + 1);
    };

    const handleOpenEdit = async (item) => {
        setEditMode(true);
        setCurrentItem(item);
        setTipoEvento(item.tipoEvento || "");
        setPlazoEnDias(item.plazoEnDias || 0);
        setObservaciones(item.observaciones || "");
        const subEstado = subEstados.find(s => s.label === item.subEstado);
        setSelectedSubEstado(subEstado || null);
        const estado = estados.find(e => e.label === item.estado);
        setSelectedEstado(estado || null);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setCurrentItem(null);
        setTipoEvento("");
        setPlazoEnDias(0);
        setObservaciones("");
        setSelectedSubEstado(null);
        setSelectedEstado(null);
    };

    const handleSubEstadoChange = (e, newValue) => {
        setSelectedSubEstado(newValue);
        setSelectedEstado(null); // Reset estado when subEstado changes
    };

    const getEstadosFiltrados = () => {
        if (!selectedSubEstado) return [];
        return estados.filter(e => e.subEstado === selectedSubEstado.label);
    };

    const handleSave = async () => {
        if (!tipoEvento.trim()) {
            setSnackbar({ open: true, msg: 'El tipo de evento es requerido', severity: 'warning' });
            return;
        }
        if (!selectedSubEstado) {
            setSnackbar({ open: true, msg: 'Debe seleccionar un sub estado', severity: 'warning' });
            return;
        }
        if (!selectedEstado) {
            setSnackbar({ open: true, msg: 'Debe seleccionar un estado', severity: 'warning' });
            return;
        }

        try {
            if (editMode) {
                const payload = {
                    idJudEventoTipo: currentItem.idJudEventoTipo,
                    tipoEvento: tipoEvento,
                    idJudEstado: selectedEstado.id,
                    plazoEnDias: parseInt(plazoEnDias) || 0,
                    observaciones: observaciones || ".",
                    activo : 1,
                    sistema : 0,
                    enviarMail : 0
                };
                const res = await pathData(`/JudEventoTipoUpdate`, payload);
                if (res?.isSuccess) {
                    setSnackbar({ open: true, msg: 'Tipo de evento judicial actualizado correctamente', severity: 'success' });
                    handleCloseDialog();
                    setDataVersion(prev => prev + 1);
                    setRefreshKey(prev => prev + 1);
                } else {
                    setSnackbar({ open: true, msg: res?.error || 'Error actualizando tipo de evento judicial', severity: 'error' });
                }
            } else {
                const payload = {
                    tipoEvento: tipoEvento,
                    idJudEstado: selectedEstado.id,
                    plazoEnDias: parseInt(plazoEnDias) || 0,
                    observaciones: observaciones || ".",
                     activo : 1,
                    sistema : 0,
                    enviarMail : 0
                };
                const res = await postData('/JudEventoTipoAlta', payload);
                if (res?.isSuccess) {
                    setSnackbar({ open: true, msg: 'Tipo de evento judicial creado correctamente', severity: 'success' });
                    handleCloseDialog();
                    setDataVersion(prev => prev + 1);
                    setRefreshKey(prev => prev + 1);
                } else {
                    setSnackbar({ open: true, msg: res?.error || 'Error creando tipo de evento judicial', severity: 'error' });
                }
            }
        } catch (ex) {
            console.error('Error guardando tipo de evento judicial', ex);
            setSnackbar({ open: true, msg: 'Error guardando tipo de evento judicial', severity: 'error' });
        }
    };

    const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

    const handleCancelDelete = () => {
        setDeleteId(null);
        setOpenDelete(false);
    };

    const handleConfirmDelete = async () => {
        if (!deleteId) return;
        try {
            const res = await deleteData(`/JudEventoTipoDelete/${deleteId}`);
            if (res?.isSuccess) {
                setSnackbar({ open: true, msg: 'Tipo de evento judicial eliminado correctamente', severity: 'success' });
                setOpenDelete(false);
                setDeleteId(null);
                setDataVersion(prev => prev + 1);
                setRefreshKey(prev => prev + 1);
            } else {
                setSnackbar({ open: true, msg: res?.error || 'Error eliminando tipo de evento judicial', severity: 'error' });
            }
        } catch (ex) {
            console.error('Error eliminando tipo de evento judicial', ex);
            const msg = ex?.message || ex?.response?.data?.detail || 'Error eliminando tipo de evento judicial';
            setSnackbar({ open: true, msg, severity: 'error' });
        }
    };

    const PaperComponent = useCallback((props) => {
        return (
            <Draggable
                handle="#draggable-dialog-title"
                cancel={'[class*="MuiDialogContent-root"]'}
            >
                <Paper {...props} />
            </Draggable>
        );
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="secondary"
                                borderRadius="lg"
                                coloredShadow="secondary"
                            >
                                <MDTypography variant="h6" color="white">
                                    Tipos de Evento Judicial
                                </MDTypography>
                            </MDBox>

                            <MDBox pt={3} py={3} px={2}>
                                {/* Filtros */}
                                <MDBox mb={3} display="flex" flexDirection="column" gap={2}>
                                    <MDBox display="flex" gap={2} flexWrap="wrap">
                                        <TextField
                                            label="Filtrar por Tipo Evento"
                                            value={filtroTipoEvento}
                                            onChange={(e) => setFiltroTipoEvento(e.target.value)}
                                            size="small"
                                            sx={{ minWidth: 250 }}
                                        />
                                        <Autocomplete
                                            options={subEstados}
                                            getOptionLabel={(option) => option.label || ""}
                                            value={filtroSubEstado}
                                            onChange={(e, newValue) => {
                                                setFiltroSubEstado(newValue);
                                                setFiltroEstado(null);
                                            }}
                                            disableClearable={false}
                                            freeSolo={false}
                                            renderInput={(params) => <TextField {...params} label="Filtrar por Sub Estado" size="small" inputProps={{...params.inputProps, readOnly: true}} />}
                                            sx={{ minWidth: 250 }}
                                        />
                                        <Autocomplete
                                            options={filtroSubEstado ? estados.filter(e => e.subEstado === filtroSubEstado.label) : []}
                                            getOptionLabel={(option) => option.label || ""}
                                            value={filtroEstado}
                                            onChange={(e, newValue) => setFiltroEstado(newValue)}
                                            disableClearable={false}
                                            freeSolo={false}
                                            disabled={!filtroSubEstado}
                                            renderInput={(params) => <TextField {...params} label="Filtrar por Estado" size="small" inputProps={{...params.inputProps, readOnly: true}} />}
                                            sx={{ minWidth: 300 }}
                                        />
                                    </MDBox>
                                </MDBox>

                                <MDBox mb={2} display="flex" gap={1}>
                                    <MDButton
                                        onClick={handleOpenAdd}
                                        variant="gradient"
                                        color="success"
                                        startIcon={<AddIcon />}
                                    >
                                        Agregar Tipo Evento
                                    </MDButton>
                                    <MDButton
                                        onClick={() => setRefreshKey(prev => prev + 1)}
                                        variant="outlined"
                                        color="info"
                                        startIcon={<SearchIcon />}
                                    >
                                        Buscar
                                    </MDButton>
                                    <MDButton
                                        onClick={handleLimpiarFiltros}
                                        variant="outlined"
                                        color="warning"
                                    >
                                        Limpiar Filtros
                                    </MDButton>
                                </MDBox>

                                {loading ? (
                                    <MDBox display="flex" justifyContent="center" alignItems="center" py={6}>
                                        <CircularProgress />
                                    </MDBox>
                                ) : (
                                    <DataTable
                                        key={`${refreshKey}-${dataVersion}`}
                                        table={{ columns, rows }}
                                        isSorted={false}
                                        showTotalEntries
                                        canSearch={false}
                                        noEndBorder
                                        pagination={{ color: 'warning', variant: 'gradient' }}
                                    />
                                )}

                                {/* Dialog Add/Edit */}
                                <Dialog 
                                    open={openDialog} 
                                    onClose={(event, reason) => {
                                        if (reason !== 'backdropClick') {
                                            handleCloseDialog();
                                        }
                                    }}
                                    disableEscapeKeyDown
                                    fullWidth 
                                    maxWidth="md"
                                    PaperComponent={PaperComponent}
                                    aria-labelledby="draggable-dialog-title"
                                >
                                    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                                        {editMode ? 'Editar Tipo de Evento Judicial' : 'Agregar Tipo de Evento Judicial'}
                                    </DialogTitle>
                                    <DialogContent>
                                        <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
                                            <TextField
                                                label="Tipo de Evento *"
                                                value={tipoEvento}
                                                onChange={(e) => setTipoEvento(e.target.value)}
                                                fullWidth
                                                required
                                            />
                                            <Autocomplete
                                                options={subEstados}
                                                getOptionLabel={(option) => option.label || ""}
                                                value={selectedSubEstado}
                                                onChange={handleSubEstadoChange}
                                                disableClearable={false}
                                                freeSolo={false}
                                                renderInput={(params) => <TextField {...params} label="Sub Estado *" inputProps={{...params.inputProps, readOnly: true}} />}
                                            />
                                            <Autocomplete
                                                options={getEstadosFiltrados()}
                                                getOptionLabel={(option) => option.label || ""}
                                                value={selectedEstado}
                                                onChange={(e, newValue) => setSelectedEstado(newValue)}
                                                disableClearable={false}
                                                freeSolo={false}
                                                disabled={!selectedSubEstado}
                                                renderInput={(params) => <TextField {...params} label="Estado *" inputProps={{...params.inputProps, readOnly: true}} />}
                                            />
                                            <TextField
                                                label="Plazo en Días"
                                                type="number"
                                                value={plazoEnDias}
                                                onChange={(e) => setPlazoEnDias(e.target.value)}
                                                fullWidth
                                                InputProps={{ inputProps: { min: 0 } }}
                                            />
                                            <TextField
                                                label="Observaciones"
                                                value={observaciones}
                                                onChange={(e) => setObservaciones(e.target.value)}
                                                fullWidth
                                                multiline
                                                rows={3}
                                            />
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="gradient" color="error" onClick={handleCloseDialog}>
                                            Cancelar
                                        </MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleSave}>
                                            Guardar
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Dialog Confirm Delete */}
                                <Dialog 
                                    open={openDelete} 
                                    onClose={(event, reason) => {
                                        if (reason !== 'backdropClick') {
                                            handleCancelDelete();
                                        }
                                    }}
                                    disableEscapeKeyDown
                                    fullWidth 
                                    maxWidth="xs"
                                >
                                    <DialogTitle>Eliminar Tipo de Evento Judicial</DialogTitle>
                                    <DialogContent>
                                        <MDBox>
                                            <MDTypography>¿Confirma que desea eliminar este tipo de evento judicial?</MDTypography>
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="gradient" color="error" onClick={handleCancelDelete}>
                                            Cancelar
                                        </MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleConfirmDelete}>
                                            Eliminar
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar}>
                                    <MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity} elevation={6} variant="filled">
                                        {snackbar.msg}
                                    </MuiAlert>
                                </Snackbar>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default JudEventoTipoListar;
